var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-item",
      attrs: {
        id: "appraisal-process-content",
        "data-cy": "appraisal-process-content",
      },
    },
    [
      _c("div", { staticClass: "appraisal-process-container" }, [
        _c("input", {
          ref: "file",
          attrs: {
            id: "appraisal-process-fileUpload",
            "data-cy": "appraisal-process-fileUpload",
            type: "file",
            hidden: "",
          },
          on: {
            change: function ($event) {
              return _vm.getAppraisalFile()
            },
          },
        }),
        _c(
          "button",
          {
            staticClass: "button is-button-second is-rounded",
            attrs: {
              id: "appraisal-upload-button",
              "data-cy": "appraisal-upload-button",
              disabled: !_vm.checkUserFeature("element.trading.button.cargar"),
            },
            on: {
              click: function ($event) {
                return _vm.showPopUpFile()
              },
            },
          },
          [_vm._m(0), _c("span", [_vm._v("Cargar Valorización")])]
        ),
      ]),
      _vm.appraisalFileCharged && !_vm.isErrorMessage
        ? _c(
            "div",
            {
              staticClass: "appraisal-inputs columns is-centered",
              attrs: { "data-cy": "appraisal-inputs" },
            },
            [
              _c(
                "div",
                { staticClass: "column is-one-third" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: "Comprador",
                        "custom-class":
                          "has-text-weight-normal has-text-align-center",
                      },
                    },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: {
                            id: "appraisal-investor",
                            "data-cy": "appraisal-investor",
                            expanded: "",
                            size: "is-small",
                            rounded: "",
                          },
                          model: {
                            value: _vm.newInvestor,
                            callback: function ($$v) {
                              _vm.newInvestor = $$v
                            },
                            expression: "newInvestor",
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              domProps: { value: _vm.defaultInvestorSelected },
                            },
                            [_vm._v("Seleccione")]
                          ),
                          _vm._l(_vm.investors, function (investor) {
                            return _c(
                              "option",
                              {
                                key: investor._id,
                                domProps: { value: investor },
                              },
                              [_vm._v(" " + _vm._s(investor.name) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: "Tipo",
                        "custom-class": "has-text-weight-normal",
                      },
                    },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: {
                            id: "appraisal-sale-type",
                            "data-cy": "appraisal-sale-type",
                            expanded: "",
                            size: "is-small",
                            rounded: "",
                          },
                          model: {
                            value: _vm.salesType,
                            callback: function ($$v) {
                              _vm.salesType = $$v
                            },
                            expression: "salesType",
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              domProps: { value: _vm.defaultSalesTypeSelected },
                            },
                            [_vm._v("Seleccione")]
                          ),
                          _vm._l(_vm.appraisalSalesTypes, function (type) {
                            return _c(
                              "option",
                              {
                                key: type.name,
                                domProps: { value: type.name },
                              },
                              [_vm._v(" " + _vm._s(type.name) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: "Fecha Venta",
                        "custom-class": "has-text-weight-normal",
                      },
                    },
                    [
                      _c("b-input", {
                        attrs: {
                          id: "appraisal-sale-date",
                          rounded: "",
                          size: "5 is-small",
                          "data-cy": "appraisal-sale-date",
                        },
                        model: {
                          value: _vm.salesDate,
                          callback: function ($$v) {
                            _vm.salesDate = $$v
                          },
                          expression: "salesDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { staticClass: "pt-3" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-primary",
                          attrs: {
                            id: "appraisal-process-button",
                            expanded: "",
                            "data-cy": "appraisal-process-button",
                            disabled: _vm.isProcessingDisabled,
                            rounded: "",
                            "icon-left": "fas fa-cog",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showConfirmModal()
                            },
                          },
                        },
                        [_vm._v(" Procesar Valorización ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("spinner", { attrs: { "is-loading": _vm.isLoading } }),
      _vm.isErrorMessage || _vm.isWrongDate || _vm.isErrorProcess
        ? _c(
            "div",
            {
              staticClass:
                "appraisal-process-info has-text-centered error-message",
              attrs: {
                id: "appraisal-process-error-title",
                "data-cy": "appraisal-process-error-title",
              },
            },
            [
              _c("span", [
                _vm._v(" " + _vm._s(_vm.isWrongDate || _vm.errorMessage) + " "),
              ]),
            ]
          )
        : _vm._e(),
      _c("AppraisalProcessConfirmModal", {
        attrs: {
          appraisal: _vm.appraisal,
          "is-component-modal-active": _vm.isComponentModalActive,
        },
        on: { process: _vm.process, cancelProcess: _vm.cancelProcess },
      }),
      _vm.appraisalResult
        ? _c(
            "div",
            [
              _c("appraisal-item", {
                attrs: { appraisal: _vm.appraisalResult, pos: 0 },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-upload" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }